/**
 * Returns a list with stopwords for the Norwegian passive voice assessment.
 *
 * @returns {Array}                 The list with stopwords.
 */
export default [
	"dette",
	"at",
	"disse",
	"på",
	"unntatt",
	"for",
	"fra",
	"i",
	"om",
	"ovenfor",
	"på tvers",
	"etter",
	"mot",
	"blant",
	"rundt",
	"som",
	"på",
	"før",
	"bak",
	"nedenfor",
	"under",
	"siden",
	"mellom",
	"utover",
	"men",
	"av",
	"når",
	"da",
	"som",
	"fordi ",
	"ikke",
	"og",
];
